export type InsuranceCarriersConfig = {
    InsuranceCarrierFeatureConfigurations: Record<
        string,
        {
            Features: Array<{
                FeatureCode: string;
                Enabled: boolean;
            }>;
        }
    >;
};

export type FeatureFlagValue = boolean | string | number | Array<string> | InsuranceCarriersConfig;

export type FeatureFlag = {
    key: string;
    defaultValue: FeatureFlagValue;
};

export const FeatureFlags = {
    accessSurePartClaimListReplaceCompanyWithCustomerName: {
        key: 'Access-SurePart-ClaimListReplaceCompanyWithCustomerName',
        defaultValue: false,
    },
    releaseSurePartReviewButtonColumn: {
        key: 'Release-SurePart-Review-Button-Column',
        defaultValue: false,
    },
    releaseSurePartAllowInsurerFrontend: {
        key: 'Release-SurePart-AllowInsurerFrontend',
        defaultValue: false,
    },
    releaseSurePartSortByPricingImpact: {
        key: 'Release-SurePart-SortByPricingImpact',
        defaultValue: false,
    },
    releaseSurePartMoveQtyColumn: {
        key: 'Release-SurePart-Move-Qty-Column',
        defaultValue: false,
    },
    accessSurePartDefaultDeliveryDays: {
        key: 'Access-SurePart-DefaultDeliveryDays',
        defaultValue: false,
    },
    accessSurepartInsuranceCarriersConfig: {
        key: 'Access-Surepart-InsuranceCarriersConfig',
        defaultValue: { InsuranceCarrierFeatureConfigurations: {} },
    },
    releaseInsurerTicketingEnabled: {
        key: 'Release-InsurerTicketing-Enabled',
        defaultValue: false,
    },
    releaseSurePartTableauReport: {
        key: 'Release-SurePart-Tableau-Report',
        defaultValue: false,
    },
    surepartFeatureResetClaimEnabled: {
        key: 'SurePart-Feature-Reset-Claim-Enabled',
        defaultValue: false,
    },
    releaseSurePartSupplierComments: {
        key: 'Release-SurePart-SupplierComments',
        defaultValue: false,
    },
    releaseSurePartSupplierQuoteReference: {
        key: 'Release-SurePart-SupplierQuoteReference',
        defaultValue: false,
    },
} as const;
